import {unref} from 'vue'
import {SID_CUSTOMER, INPUT_DATE} from '@/tourist/tourist-store.js'
import {CRUISE_CONSTRUCTOR} from '@/cstore.js'


export const book_sumV = (calc_prices) => {
    let vals = Object.values( calc_prices )
    let ret = { v: ['', 1] } // нет суммы
    if ( vals.length ) {
        let sums = vals.map( ({v:[p,c]}) => toflo(p)  )
        let price = sums.reduce( (akk, sum) => akk + sum, 0 )
        let currency = vals[0].v[1]
        ret= {v: [price, currency]}
    }
    return ret
}
const toflo = sum => {
    if ("string" === typeof(sum)) {
        sum = sum.replace(/[^0-9,.]/g,'')
        sum = sum.replace(/,/g,'.')
        sum = parseFloat(sum, 10)
    }
    return sum
}

const place_num = ({pnum}) => {
    const ret = pnum >= 0 ? `Место ${pnum+1}` : 'Ребенок без места'
    return ret
} 

// получить туристов введенных ранее и не привязанных к текущему круизу
export const getEarlierSids = ( tstore, bookCabins ) => {
    const used = bookCabins.getAdultSids(false) // получить все
    const all = tstore.pers.map( ({sid}) => sid )
    const allset = new Set(all)
    const usedset = new Set(used)
    for (let sid of allset) {
        if ( usedset.has(sid) ) {
            allset.delete(sid)
        }
    }
    const ret = allset.values().toArray()
    return ret
}

export const beforeBookCheck = (cstore, tstore, bookCabins) => {
    const errs = []

    const passengers = []
    let customer = {}
    const comment = bookCabins.notes_for_book()

    const isCons = bookCabins.bookBox.cruiseIdFull === CRUISE_CONSTRUCTOR 
    const getCabins = isCons ? [cstore.getCabinCons] : cstore.getCabins

    if (!getCabins.length) {

        let text = 'Нечего бронировать! Выберите каюты'
        errs.push({text, cabinId: bookCabins.customerCabinId})

    } else {

        getCabins.forEach( ({id:cabinId, /*Cabin,*/ places}) => {
            places.forEach( (place, ind) => {
    //            const num = ind + 1
                const personItem = bookCabins.personItem( cabinId, place )
//console.log('personItem', personItem)
    //console.log('bookCabins.personItem( cabinId, place )', a, cabinId, place)
                const {sid} = unref(personItem)
/*                let sid
                if (personItem) {
                    sid = unref( personItem ).sid
                }*/

                if (!sid) {
                    errs.push({text: `${place_num(place)} - заполните`, cabinId})
                } else {
                    const person = tstore.person(sid)
                    if (!person || !person.vest.isValid) {
                        let text = `${place_num(place)} - есть ошибки`
                        errs.push({text, cabinId})
                    } else {
                        const person_for_book = person_bookData( person, isCons ? 0 : cabinId  )
                        passengers.push( person_for_book )
                    }
                }
            }  )
        } )
        const cperson = tstore.person( SID_CUSTOMER )
        if (!cperson.vest.isValid) {
            let text = 'Заказчик -  есть ошибки'
            errs.push({text, cabinId: bookCabins.customerCabinId})
        } else {
            customer = person_bookData(cperson)
        }


        const precalc = unref(bookCabins.getBookPrecalc())
        const calc = precalc ? precalc.calc : false
        if (calc && calc.ok && !calc.acc) {
            let text = `Измените размещение, либо бронируйте по одной каюте: ${calc.error}`
            errs.push({text, cabinId: bookCabins.customerCabinId})
        }
    }

    const e0 = () => {
        return { 
            is: false, 
            texts: [],
        }
    }

    let eEntr = getCabins.map( ({id}) => [ id, e0() ] )
    eEntr.push( [bookCabins.customerCabinId, e0() ] )
    const eBy = Object.fromEntries( eEntr )

    const errsByCabin = errs.reduce( (akk, error) => {
        const {text, cabinId} = error
        akk[cabinId].is = true
        akk[cabinId].texts.push( text )

        return akk
    }, eBy  )

    const travelers = {passengers, customer, comment}
    return { errs, errsByCabin, travelers }
}

export const dmy2ymd = d => {
    let p = d.split('.')
    return `${p[2]}-${p[1]}-${p[0]}`
}

const person_bookData = (person, cabin_id = null)  => {
    const fields_array = fieldsInOrder(person)
    const fields = new Set( fields_array )

    const p_is_ru = is_ru(person)
    const p_isZps = isZps(person)
    const p_isPs = isPs(person)
    const p_is_cust = is_cust(person)
    const p_hasValid = hasValid(person)

    const person_get = ff => {
        let val = fields.has(ff) ? person[ff].val : ''
        if (val && INPUT_DATE === person[ff].type) {
            val = dmy2ymd(val)
        }
        return val
    }

    const ret = {}
    ret.cabin_id = cabin_id
    ret.passenger_type = p_is_cust ? null : person.tt.status

    ret.male = person_get('male')
    ret.birthday = person_get('born')

    ret.last_name = p_is_ru ?  person.fname.val : person.flname.val
    ret.first_name = p_is_ru ? person.iname.val : person.ilname.val
    ret.middle_name = p_is_ru ? person.oname.val : ''

    ret.last_lname = p_is_ru && !p_isZps ? person.fname.val : person.flname.val
    ret.first_lname = p_is_ru && !p_isZps ? person.iname.val : person.ilname.val
    ret.middle_lname = p_is_ru && !p_isZps ? person.oname.val : ''

    ret.doc_type = person_get('doc_type')

    ret.doc_issue = person_get('doc_issue')
    ret.doc_valid = person_get('doc_valid')

    ret.doc_series = person_get('doc_serie')
    ret.doc_number = person_get('doc_number')
    ret.country = person_get('doc_gra')

    ret.phone = person_get('phone')
    ret.email = person_get('email')
    ret.address = person_get('doc_address')
    ret.zip = person_get('doc_zip')
    ret.punitcode = person_get('doc_unitcode')
    ret.pauthority = person_get('doc_authority')

    return ret
}

const person_name = (person, num) => {
    let n = `${person.iname.val} ${person.fname.val}`.trim()
    if (!n) {
        n = `${person.ilname.val} ${person.flname.val}`.trim()
    }
    if (!n) {
        n = num
    }
    return n
}

const sokrati = (str, point) => {
    let r = ''
    if (str.length) {
        r = point ? str.substr(0,1).toUpperCase()+'.' : str
    }
    return r
}

export const fio_person = (person, point=false) => {
    let r = ''
    if ('RU' === person.doc_gra.val) {
        let a = person.fname.val
        if (a) {
            let b = sokrati(person.iname.val, point)
            let c = sokrati(person.oname.val, point)
            r = [a,b,c].join(' ').trim()
        }
    } else {// на английском не сокращаем IVANOV IVAN, не принято
        r = `${person.ilname.val} ${person.flname.val}`.trim()
    }
    return r
}


const is_cust = (person) => {
    return person.sid === SID_CUSTOMER 
}

const is_ru = (person) => {
    return 'RU' === person.doc_gra.val
}

const isZps = (person) => {
    return 'zps' === person.doc_type.val 
}
const isPs = (person) => {
    return 'ps' === person.doc_type.val 
}
const hasValid = (person) => {
    let val = person.doc_type.val 
    let ret = ['zps', 'other'].includes(val)
    return ret
}




export const fieldsInOrder = person => {
    const p_is_ru = is_ru(person)
    const p_isZps = isZps(person)
    const p_isPs = isPs(person)
    const p_is_cust = is_cust(person)
    const p_hasValid = hasValid(person)


    let ff = ["doc_gra"]
    ff = p_is_ru ?  [...ff, "fname", "iname", "oname"] : [...ff, "flname", "ilname"]
    ff = [...ff, "male", "born"]
    ff = [...ff, "doc_type", "doc_serie", "doc_number", "doc_issue" ]
    if (p_hasValid) {
        ff = [...ff, "doc_valid"]
    }
    if (p_is_ru && p_isZps) {
        ff = [...ff, "flname", "ilname"]
    }
    if (p_is_cust) {
        if (p_isPs) {
            ff = [ ...ff, "doc_unitcode", "doc_authority"  ]
        }
        ff = [ ...ff, "doc_address", "doc_zip" ]
        ff = [ ...ff, "phone", "email" ]
    }

    return ff
}
